import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { UserHeaderInfoComponent } from '@shared/components';
import { authFeature } from '@store';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [RouterLink, UserHeaderInfoComponent, AsyncPipe],
})
export class HeaderComponent {
  store = inject(Store);
  activeUser$ = this.store.select(authFeature.selectUser);
}
